import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Fleet from "@/pages/Fleet";
import FleetDetail from "@/pages/FleetDetail";
import BookingPage from "@/pages/BookingPage";
import Contact from "@/pages/Contact";
import AreaPage from "@/pages/AreaPage";
import Blog from "@/pages/Blog";
import Article from "@/pages/Article";
import Admin from "@/pages/Admin";
import Policies from "@/pages/Policies";
import Complaints from "@/pages/Complaints";
import LostProperty from "@/pages/LostProperty";
import BusinessAccounts from "@/pages/BusinessAccounts";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fleet" element={<Fleet />} />
            <Route path="/fleet/:slug" element={<FleetDetail />} />
            <Route path="/book" element={<BookingPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/areas/:slug" element={<AreaPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Article />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/complaints" element={<Complaints />} />
            <Route path="/lost-property" element={<LostProperty />} />
            <Route path="/business" element={<BusinessAccounts />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors theme="light" />
      </div>
    </HelmetProvider>
  );
}

export default App;
